<script setup lang="ts">
import { AppFlicker } from '@libs/ui';

import type { CurrentMonthLoaderDayTile } from '../models';

interface CurrentMonthLoaderDayTileViewProps {
  calendarTile: CurrentMonthLoaderDayTile;
  showPrices: boolean;
}

const props = defineProps<CurrentMonthLoaderDayTileViewProps>();
</script>

<template>
  <div class="current-month-loader-day-tile-view">
    {{ props.calendarTile.text }}
    <div v-if="props.showPrices" class="flicker-wrapper">
      <AppFlicker width="spacing-32" height="spacing-12" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '../styles/price_calendar_mixins' as *;

.current-month-loader-day-tile-view {
  width: var(--calendar-tile-size);
  height: var(--calendar-tile-size);

  @include calendar-tile-day-font;
  color: var(--calendar-tile-day-font-color);

  display: flex;
  gap: var(--calendar-tile-day-price-gap);
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .flicker-wrapper {
    height: var(--calendar-price-placeholder-height);
  }
}
</style>
